import {
    ApiClient,
    CurrentStageAndConfig,
    getCurrentStageAndConfig,
} from "@amzn/rangoli-seller-desktop-async-call-wrapper/src/index";

const { config: currentStage }: CurrentStageAndConfig =
    getCurrentStageAndConfig();

const smartposConfig = {
    url: currentStage.smartPosUrl,
};

const smartbizConfig = {
    url: currentStage.smartbizUrl,
};

const storeFrontProductShareConfig = {
    url: currentStage.storeFrontUrl,
};

const templateDownloadConfig = {
    url: currentStage.templateDownload,
};

const smartposClient = new ApiClient(smartposConfig);
const smartbizClient = new ApiClient(smartbizConfig);

export const smartposUrl = smartposClient.api(),
    smartbizUrl = smartbizClient.api(),
    storeFrontProductShareUrl = storeFrontProductShareConfig.url,
    bulkUploadTemplateDownloadUrl = templateDownloadConfig.url;
